<template>
  <div id="address_form">

    <div class="combined_div">
      <c-object-input :required="required" v-model:value="address.postCode"
                      :options="postalPrefills"
                      :editable="true" :placeholder="formattedPostCodePlaceholder"/>

      <c-input :required="required" v-model:value="address.city" :type="'text'"
               :placeholder="$t('address.city')"/>

    </div>
    <InputSelect :required="required" v-model:value="address.street" :options="streetPrefills"
                 :editable="true" :placeholder="formattedStreetPlaceholder"/>

    <div class="combined_div">
      <c-input :required="required" v-model:value="address.number" :type="'text'"
               :placeholder="$t('address.number')"/>
      <c-input class="bus" v-model:value="address.busNumber" :type="'text'"
               :required="false"
               :placeholder="$t('address.busNumber')"/>
    </div>
    <c-input :required="required" v-model:value="address.country" :type="'text'"
             :placeholder="$t('address.country')"/>
  </div>
</template>

<script>
import Input from '@/components/form/Input';
import postalCodes from '@/data/zipcode-belgium.json';
import InputSelect from '@/components/form/InputSelect';
import streetService from '@/services/cebeoService/modules/streetService';
import ObjectInputSelect from '@/components/form/ObjectInputSelect';

export default {
  name: 'AddressForm',

  props: {
    address: { required: true },
    required: {
      required: false,
      default: true
    }
  },

  components: {
    'c-input': Input,
    'c-object-input': ObjectInputSelect,
    InputSelect
  },

  data() {
    return {
      postalCodes: postalCodes,
      postalPrefills: [],
      streetPrefills: [],
    };
  },

  computed: {
    formattedPostCodePlaceholder() {
      if (this.required) {
        return `${this.$t('address.postcode')}*`;
      }

      return this.$t('address.postcode');
    },

    formattedStreetPlaceholder() {
      if (this.required) {
        return `${this.$t('address.street')}*`;
      }

      return this.$t('address.street');
    },
  },

  created() {
    this.postalPrefills = this.postalCodes
      .slice(0, 5)
      .map((code) => {
        return {
          value: code.zip,
          description: code.city
        };
      });
  },

  watch: {
    'address.postCode': {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue === undefined || newValue === '') {
          return;
        }

        if (typeof newValue === 'object') {
          this.address.postCode = newValue.value;
          this.address.city = newValue.description
            .trim();
          this.address.country = this.$t('belgie');
          return;
        }

        this.postalChanged();
      }
    },

    'address.street': {
      immediate: true,
      deep: true,
      handler(street) {
        if (street !== undefined) {
          const data = {
            postalCode: this.address.postCode,
            street: this.address.street
          };
          streetService.searchStreet(data)
            .then((res) => {
              this.streetPrefills = res;
            });
        }
      }
    }
  },

  methods: {
    postalChanged() {
      const code = this.address.postCode;

      if (code !== undefined && code.length > 0) {
        this.postalPrefills = this.postalCodes
          .filter((x) => x.zip.indexOf(code.trim()) === 0)
          .slice(0, 5)
          .map((code) => {
            return {
              value: code.zip,
              description: code.city
            };
          });
      } else {
        this.postalPrefills = [];
      }

      const data = {
        postalCode: this.address.postCode,
        street: this.address.street
      };
      streetService.searchStreet(data)
        .then((res) => {
          this.streetPrefills = res;
        });
    },

  }
};
</script>
<style scoped>
.combined_div {
  @apply flex justify-between
}

#address_form {
  max-width: 600px;
  @apply grid my-3 grid-rows-4 gap-y-3 m-0 mx-auto;
}

.combined_div > .c-input-select {
  width: 275px;
}

@media only screen and (max-width: 800px) {
  #address_form {
    max-width: 600px;
    @apply flex my-3 flex-col gap-y-3 m-0 mx-auto;
  }

  .combined_div > .c-input-select {
    width: 100%;
    @apply mb-3;
  }

  .combined_div {
    @apply flex flex-col
  }

  .bus {
    @apply mt-3;
  }
}

</style>
